import Env from '@/utils/env'

/**
 * Creates a formatted utility link by replacing placeholders and adding query parameters
 * @param apiUrl - The base API URL that may contain {utility_ref_id} placeholder
 * @param utilityRefId - Optional reference ID to replace {utility_ref_id} placeholder and/or add as query param.
 * @returns Formatted URL string with protocol, hostname, pathname and query parameters
 */
export const createUtilityLink = (apiUrl: string, utilityRefId?: string) => {
  if (apiUrl.includes(`{utility_ref_id}`) && utilityRefId) {
    apiUrl = apiUrl.replace('{utility_ref_id}', utilityRefId)
  }
  const url = new URL(apiUrl)
  const searchParams = url.searchParams
  if (utilityRefId && !searchParams.get('refId')) {
    searchParams.set('refId', utilityRefId)
  }
  // helper to set redirect urls to localhost in dev
  if (searchParams.get('redirect_url') && Env.isLocal) {
    searchParams.set(
      'redirect_url',
      (searchParams.get('redirect_url') ?? '').replace(
        'staging.optiwatt.com',
        'localhost:3000',
      ),
    )
  }
  return `${url.protocol}//${url.hostname}${
    url.pathname
  }?${searchParams.toString()}`
}
